export enum ECategoryType {
  Post = "Post",
  LandingPage = "LandingPage"
}
export enum ESwapType {
  up = 'up',
  down = 'downs'
}